import { updateHomeShippingGroup }        from './home-delivery';
import { updateStoreShippingGroup }       from './pickup-in-store';
import { updateRelayPointShippingGroup }  from './relay-point';
import { init as initStateButtonsHandler }from '../state-button-handler';
import { stateReexButton }                from './shipping-reex';
import { i18n } from '@/commons/utils';



export function checkShippingGroup () {
  if(!cube.$('[name="delivery-type"]:checked') && cube.$id('shippingFees-orde-summary')) {
    cube.$id('shippingFees-orde-summary').classList.add('hide');
    cube.$class('js-total-with-shipping').forEach(e => e.classList.add('hide'));
    cube.$class('js-total-without-shipping').forEach(e => e.classList.remove('hide'));
  }
};

function setPanel(){
  if(cube.$('input[name="delivery-type"]:checked')) {

    cube.$$('.checkout__shipping__wrapper').forEach(element => {
      element.classList.remove('checkout__shipping__wrapper--deployed');
      element.classList.remove('checkout__shipping__wrapper--selected');
    });

    const inputSelectedClass = cube.$('input[name="delivery-type"]:checked').closest('.checkout__shipping__wrapper').classList;
    inputSelectedClass.add('checkout__shipping__wrapper--selected');
    inputSelectedClass.add('checkout__shipping__wrapper--deployed');
  } else {
    initStateButtonsHandler();
  }
};

function getDeliveryTypeFromElement(element){
  const deliveryDataset = element.dataset || {};
  return deliveryDataset.type;
};

function reloadOrderSummary(){
  cube.cartridge('checkout-order-summary').reload();
};

function confirmDelivery(){
  //Picked by another personn verification, this is the complete selector : cube.$('input[data-type="pick-up"]:checked + .checkout__shipping__label + .checkout__shipping__store .js-is-picked);
  const caseCn = cube.$('[data-type="pick-up"]:checked + * + div .js-is-picked') === null;
  const caseGlobal = cube.$('[data-type="pick-up"]:checked + * + div [type="checkbox"]:checked');
  const friendName  = cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-pickup-friend-name');
  const friendPhone = cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-pickup-friend-phone');
  const pickUpIsCheck = cube.$('[data-type="pick-up"]:checked');

  if(pickUpIsCheck && (caseGlobal && (friendName.closest('.form-group').classList.contains('has-error') || friendPhone.closest('.form-group').classList.contains('has-error')))) {
    return false;
  } else if(pickUpIsCheck && (caseCn || caseGlobal)) {
    if(friendName.value.trim() === '' || friendPhone.value === '') {
      if(friendName.value.trim() === '') {
        friendName.closest('.form-group').classList.add('has-error');
        friendName.nextElementSibling.$('.text').textContent = window.Messages('validationMsg.required');
      }
      if(friendPhone.value === '') {
        friendPhone.closest('.form-group').classList.add('has-error');
        friendPhone.nextElementSibling.$('.text').textContent = window.Messages('validationMsg.phone');
      }
      return false;
    } else if(friendName.closest('.form-group').classList.contains('has-error') || friendPhone.closest('.form-group').classList.contains('has-error')) {
      return false;
    }
  }

  cube.ajax.post('rest/model/atg/commerce/order/purchase/ShippingGroupActor/validateShippingGroupStage')
    .onSuccess((response) => {
      confirmDeliverySucccess(response.responseTO);
    })
    .onError(confirmDeliveryError)
    .call();
  return true;


};

function confirmDeliverySucccess(response){
  const redirect = response.data.redirect;
  const url      = response.data.url;

  if(!redirect) {
    reloadOrderSummary();
    if(response.errors[0] && response.errors[0].code) {
      cube.alert.error(i18n(response.errors[0].code));
    }
  } else {
    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.queue.send('proceedToPayment');
    }
    const responseTODataUrl = Cube.Utils.localizeUri(url) ;
    window.location.href = '{0}//{1}{2}'.format(window.location.protocol, window.location.host , responseTODataUrl);
  }
};

function confirmDeliveryError(){
  cube.event.send('checkout:error', {message: 'Form not valid ?'});
};

function changeDelivery(event){
  const deliveryType    = getDeliveryTypeFromElement(event.currentTarget);
  const wrapperSelected = cube.$('.checkout__shipping__wrapper--selected');
  const panelBody       = event.currentTarget.closest('.checkout__shipping__content');
  const panelHeader     = panelBody.previousSibling;

  stateReexButton();
  //Close delivery tooltip info when you select an input
  closeTooltip();

  // Push address content for carrier selected
  if(event.currentTarget.closest('.checkout__shipping__wrapper').classList.contains('checkout__shipping__home-delivery') && panelBody.$$('input[data-type="home-delivery"]').length > 1) {
    $('.checkout__shipping__home-delivery .checkout__shipping__store').insertAfter($('input[data-type="home-delivery"]:checked + label'));
  }

  // Select delivery type
  switch (deliveryType) {
    case 'home-delivery':
      updateHomeShippingGroup(event);
      break;
    case 'pick-up':
      updateStoreShippingGroup(event);
      break;
    case 'relay-point':
      updateRelayPointShippingGroup(event);
      break;
    default :
      break;
  }

  if(wrapperSelected && !wrapperSelected.$('input[name="delivery-type"]:checked'))
    wrapperSelected.classList.remove('checkout__shipping__wrapper--selected');

  if(panelBody.$$('input[name="delivery-type"]:checked').length > 0 && !panelHeader.parentNode.classList.contains('checkout__shipping__wrapper--selected'))
    panelHeader.parentNode.classList.add('checkout__shipping__wrapper--selected');

  let value;
  if (deliveryType === 'relay-point'){
    value = event.currentTarget.getAttribute('data-rpshippingoptionid');
  }else if(deliveryType === 'home-delivery'){
    value = event.currentTarget.id;
  }else{
    value = '';
  }
  tc_vars['order_shipping_method_option'] = value;
  initStateButtonsHandler();
};

// Exported
function updateTotalAmount(){
  if(cube.$('.dkt-total-line-amount'))
    cube.$('.dkt-total strong').innerHTML = cube.$('.dkt-total-line-amount').innerHTML;
};

// Exported
function togglePanel(event){
  event.stopImmediatePropagation();

  const panelHeader     = event.currentTarget;
  const panelBody       = panelHeader.nextElementSibling;
  const wrapper         = 'checkout__shipping__wrapper';
  const wrapperSelected = `${wrapper}--selected`;
  const wrapperDeployed = `${wrapper}--deployed`;

  //Close delivery tooltip info when you open a delivery method
  closeTooltip();

  if(!panelHeader.parentNode.classList.contains(`${wrapper}--unavailable`)) {

    if(!panelHeader.parentNode.classList.contains(wrapperDeployed)) {
      panelHeader.parentNode.classList.add(wrapperDeployed);
    } else {
      panelHeader.parentNode.classList.remove(wrapperDeployed);

      if(cube.$(`.${wrapperSelected}`) && !cube.$(`.${wrapperSelected} input[name="delivery-type"]:checked`))
        cube.$(`.${wrapperSelected}`).classList.remove(wrapperSelected);

      if(panelBody.$$('input[name="delivery-type"]:checked').length > 0 && !panelHeader.parentNode.classList.contains(wrapperSelected))
        panelHeader.parentNode.classList.add(wrapperSelected);

    }
  }
};

function toggleTooltip(event) {
  $(this).closest('.checkout__shipping__form').find('.shipping-tooltip').not($(this)).removeClass('shipping-tooltip--opened');
  $(this).toggleClass('shipping-tooltip--opened');
  event.stopPropagation();
}

function closeTooltip() {
  const tooltipsDelivery = cube.$$('.shipping-tooltip');

  if(tooltipsDelivery.length > 0) {
    tooltipsDelivery.forEach(element => {
      element.classList.remove('shipping-tooltip--opened');
    });
  }
}

function bindPannel(){
  const headers = cube.$$('.checkout__shipping__header');
  const tooltips = cube.$$('.shipping-tooltip');

  headers.forEach(element => {
    element.addEventListener('click', togglePanel);
  });
  tooltips.forEach(element => {
    element.addEventListener('click', toggleTooltip);
  });

};

/* (づ￣ ³￣)づ LUL... */
function setCartridgeUrl(path, url, cartridgeId){
  let adressBook = null;

  if(cartridgeId){
    adressBook = cube.$id(cartridgeId);
  }else{
    adressBook = cube.$id('address-book');
  }

  if (undefined !== path) {
    if (undefined !== url) {
      adressBook.dataset.tPath = path;
      adressBook.dataset.tUrl = encodeURI(url);
    }
    else {
      adressBook.dataset.tPath = path;
    }
  }
  else if (undefined !== url) {
    adressBook.dataset.tUrl = encodeURI(url);
  }
};

// Exported
function utils(){
  // At display check if input is selected and open his parent.
  setPanel();
};

export {utils, confirmDelivery, updateTotalAmount, togglePanel, bindPannel, setCartridgeUrl, changeDelivery, reloadOrderSummary};



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/shipping-utils.js